const common = {
  black: '#000',
  white: '#fff'
};
export default common;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/colors/common.js
// module id = 802
// module chunks = 25